import { useState } from "react";
import { Button, Col, Input, Row } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { moveUserToClasses } from "../../Utilities/moveUserHelper";
import SchoolClassPicker from "./SchoolClassPicker";

// Flyttar en elev eller lärare, en i taget, utan att först söka fram användaren: för supportärenden
// som "flytta de här eleverna till klass X". E-postadressen och vald skola och klass ligger kvar efter
// en flytt, så det syns vem som flyttades och nästa adress kan bytas in direkt.
export default function MoveUser() {
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [target, setTarget] = useState({ schoolId: null, classId: null });
  const [isMoving, setIsMoving] = useState(false);

  const canMove = email.trim() !== "" && target.classId !== null && !isMoving;

  const move = async () => {
    setIsMoving(true);

    await moveUserToClasses(intl, email.trim(), [target.classId]);

    setIsMoving(false);
  };

  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col xs="3" className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="MoveUserSectionTitle" />
          </h5>
        </Col>
      </Row>
      <Row>
        <Col xs="3" className="mb-2">
          <Input
            id="user-move-email"
            autoComplete="off"
            placeholder={intl.formatMessage({ id: "MoveUserEmailPlaceholder" })}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter" && canMove) {
                move();
              }
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs="3">
          <SchoolClassPicker value={target} onChange={setTarget} />
        </Col>
      </Row>
      <Row>
        <Col xs="4" className="mb-2 text-muted input-feedback">
          <FormattedMessage id="MoveUserSectionNote" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button color="primary" outline disabled={!canMove} onClick={move}>
            <FormattedMessage id={isMoving ? "Moving" : "Move"} />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
